<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout>
        <v-layout wrap pa-0 mb-0>
            <v-flex xs12 sm12 md12>
                <v-select
                        :items="[{value: 0, text:'Без задержки'}, {value: 1, text: 'Через заданное время'}, {value: 2, text: 'Через количество дней и в заданное время'}]"
                        label="Задержка"
                        v-model="messageModel.sleep_type"
                        item-text="text"
                        item-value="value"
                        @change="changeSleepType"
                />
            </v-flex>
            <v-flex xs6 sm6 md6 v-if="messageModel.sleep_type !== 0">
                <v-select
                        :items="times"
                        label="Количество дней"
                        v-model="countDay"
                        item-text="text"
                        item-value="value"
                />
            </v-flex>
            <v-flex xs6 sm6 md6 v-if="messageModel.sleep_type !== 0">
                <v-menu
                        ref="menu"
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="time"
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                                v-model="datePicker"
                                label="Задать время"
                                prepend-icon="access_time"
                                readonly
                                v-on="on"

                        />
                    </template>
                    <v-time-picker
                            no-title
                            format="24hr"
                            v-if="menu2"
                            v-model="datePicker"
                            full-width
                            use-seconds
                            @click:second="$refs.menu.save(time)"
                    />
                </v-menu>
            </v-flex>
            <v-flex xs6 sm6 md6>
                <v-switch v-model="messageModel.dont_parse_links"
                          inset
                          label="Не парсить ссылки"
                          color="blue lighten-2"
                          @change="$emit('saveMessage')"
                />
            </v-flex>
            <v-flex xs6>
                <v-select
                        :items="[{value:1, text:'Бот включен'},{value:0, text:'Бот выключен'},{value:2, text:'Всегда'}]"
                        label="Условие работы"
                        v-model="messageModel.work"
                        value="0"
                        item-text="text"
                        item-value="value"
                        @change="$emit('saveMessage')"
                />
            </v-flex>
            <v-flex xs6 sm6 md6>
                <v-switch v-model="messageModel.private_answer"
                          inset
                          label="Отвечать в лс?"
                          color="blue lighten-2"
                          @change="$emit('saveMessage')"
                />
            </v-flex>
        </v-layout>
    </v-layout>
</template>

<script>
export default {
    name: 'MessageSettingBlock',
    data() {
        return {
            time: null,
            menu2: false,
            sleepChain: 0,
            times: [
                { value: 0, text: '0 дней' },
                { value: 1, text: '1 день' },
                { value: 2, text: '2 день' },
                { value: 3, text: '3 дня' },
                { value: 4, text: '4 дня' },
                { value: 5, text: '5 дней' }
            ]
        }
    },
    props: ['messageModel'],
    methods: {
        changeSleepType() {
            this.messageModel.sleep_chain = this.messageModel.sleep_type === 0 ? null : this.countDay + ',' + this.datePicker
            this.$emit('saveMessage')
        }
    },
    computed: {
        countDay: {
            get() {
                return this.messageModel.sleep_chain !== null && this.messageModel.sleep_chain !== undefined
                    ? parseInt(this.messageModel.sleep_chain.split(',')[0], 10) : 0
            },
            set(value) {
                this.messageModel.sleep_chain = value + ',' + this.datePicker
                this.$emit('saveMessage')
            }
        },
        datePicker: {
            get() {
                return this.messageModel.sleep_chain !== null && this.messageModel.sleep_chain !== undefined
                    ? this.messageModel.sleep_chain.split(',')[1] : '12:00:00'
            },
            set(value) {
                value = value.replace(/NaN/g, '00')
                this.messageModel.sleep_chain = this.countDay + ',' + value
                this.$emit('saveMessage')
            }
        }
    }
}
</script>

<style scoped>

</style>
